import React, { useEffect, useRef } from 'react';
import Icon from '../ui/Icon';
import './LevelUp.css';

// Only ever rendered by a caller that already confirmed a REAL computed
// level change (fromLevel !== toLevel, both read from GET
// /portal/player-profile before/after an attempt) — never triggers on its
// own guess. Stronger motion/glow than any other interaction is deliberate
// (docs/UI_UX_ARCHITECTURE.md §1) and respects reduced-motion via the
// --z-duration-celebrate token collapsing to 0ms.
const LevelUp = ({ fromLevel, toLevel, onDismiss }) => {
  const cardRef = useRef(null);
  useEffect(() => { cardRef.current?.focus(); }, []);

  return (
    <div className="z-levelup-root" role="dialog" aria-modal="true" aria-label={`Level up, level ${fromLevel} to ${toLevel}`}>
      <div className="z-levelup-card" tabIndex={-1} ref={cardRef} onKeyDown={(e) => { if (e.key === 'Escape' || e.key === 'Enter') onDismiss(); }}>
        <div className="z-levelup-glow" aria-hidden="true" />
        <span className="z-levelup-eyebrow">LEVEL UP</span>
        <div className="z-levelup-transition">
          <span className="z-levelup-from">{fromLevel}</span>
          <span className="z-levelup-arrow" aria-hidden="true"><Icon name="arrow-right" size={20} /></span>
          <span className="z-levelup-to">{toLevel}</span>
        </div>
        <p className="z-levelup-copy">Your aptitude journey continues.</p>
        <button type="button" className="z-levelup-btn" onClick={onDismiss}>Continue</button>
      </div>
    </div>
  );
};

export default LevelUp;
